module.exports = __webpack_public_path__ + "img/speed_BG.620b44f6.png";